import { useMemo } from "react";
import { useAuthState } from "context/";
import { useSinkState } from "context/sink";
import { PERMISSION_LEVEL_ADMIN } from "constants/index";

/** Org admin, fybr admin, or folder admin on any folder — matches tag delete rules in the API. */
export function useCanDeleteTags(): boolean {
  const { currentUser } = useAuthState();
  const { sink } = useSinkState();
  return useMemo(
    () =>
      currentUser?.organization_role === "admin" ||
      currentUser?.organization_role === "fybr_admin" ||
      sink.folders.some((f) => f.level >= PERMISSION_LEVEL_ADMIN),
    [currentUser, sink.folders]
  );
}
